(function ($) {
  $(window).on("load", function () {
    // makes sure the whole site is loaded
    const $svg = $("svg.telegram").css("opacity", "1").drawsvg();
    //$("#status").fadeDelay(600); // will first fade out the loading animation
    $("#preloader").delay(1200).fadeOut('slow',() => {
      $svg.drawsvg("animate", {
        duration: 5000,
        easing: "linear",
      });
    });

    $('.lead.cta').on('touchstart mouseenter', () => {
      $svg.drawsvg('animate');
    });
  });
})(jQuery);


let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);
document.documentElement.style.setProperty('--hero-offset', window.screen.availHeight != window.innerHeight ? "-74px" : "0px");


window.addEventListener('resize', () => {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
  document.documentElement.style.setProperty('--hero-offset', window.screen.availHeight != window.innerHeight ? "-74px" : "0px");
});
